/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Onboarding_Demo_DescInputs */

const en_ui_onboarding_demo_desc = /** @type {(inputs: Ui_Onboarding_Demo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A year of runs and rides`)
};

const de_ui_onboarding_demo_desc = /** @type {(inputs: Ui_Onboarding_Demo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Jahr Läufe und Radtouren`)
};

/**
* | output |
* | --- |
* | "A year of runs and rides" |
*
* @param {Ui_Onboarding_Demo_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_demo_desc = /** @type {((inputs?: Ui_Onboarding_Demo_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_Demo_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_demo_desc(inputs)
	return de_ui_onboarding_demo_desc(inputs)
});